import shareProduct from './lib/share-product';
export default shareProduct;